/* eslint-disable */
/**
 * Generated `api` utility.
 *
 * THIS CODE IS AUTOMATICALLY GENERATED.
 *
 * To regenerate, run `npx convex dev`.
 * @module
 */

import type * as assignments from "../assignments.js";
import type * as crons from "../crons.js";
import type * as enrollment from "../enrollment.js";
import type * as fluency from "../fluency.js";
import type * as learning from "../learning.js";
import type * as legacyImport from "../legacyImport.js";
import type * as lib_env from "../lib/env.js";
import type * as lib_identity from "../lib/identity.js";
import type * as lib_retention from "../lib/retention.js";
import type * as lib_serverSecret from "../lib/serverSecret.js";
import type * as library from "../library.js";
import type * as model_assignmentShapes from "../model/assignmentShapes.js";
import type * as model_assignments from "../model/assignments.js";
import type * as model_enrollment from "../model/enrollment.js";
import type * as model_fluency from "../model/fluency.js";
import type * as model_legacyImport from "../model/legacyImport.js";
import type * as model_orientation from "../model/orientation.js";
import type * as model_readerCopy from "../model/readerCopy.js";
import type * as model_recording from "../model/recording.js";
import type * as model_research from "../model/research.js";
import type * as model_runShapes from "../model/runShapes.js";
import type * as model_runStore from "../model/runStore.js";
import type * as model_runs from "../model/runs.js";
import type * as model_submission from "../model/submission.js";
import type * as model_validators from "../model/validators.js";
import type * as model_voiceFollow from "../model/voiceFollow.js";
import type * as model_withdrawal from "../model/withdrawal.js";
import type * as model_worksheets from "../model/worksheets.js";
import type * as orientation_awrf from "../orientation/awrf.js";
import type * as orientation_interactions from "../orientation/interactions.js";
import type * as orientation_parentChoice from "../orientation/parentChoice.js";
import type * as orientation_phases from "../orientation/phases.js";
import type * as orientation_runs from "../orientation/runs.js";
import type * as orientation_sessions from "../orientation/sessions.js";
import type * as orientation_state from "../orientation/state.js";
import type * as orientation_worker from "../orientation/worker.js";
import type * as rateLimits from "../rateLimits.js";
import type * as readerCopy from "../readerCopy.js";
import type * as research from "../research.js";
import type * as stats from "../stats.js";
import type * as voiceFollow from "../voiceFollow.js";
import type * as worksheets from "../worksheets.js";

import type {
  ApiFromModules,
  FilterApi,
  FunctionReference,
} from "convex/server";
import { anyApi, componentsGeneric } from "convex/server";

const fullApi: ApiFromModules<{
  assignments: typeof assignments;
  crons: typeof crons;
  enrollment: typeof enrollment;
  fluency: typeof fluency;
  learning: typeof learning;
  legacyImport: typeof legacyImport;
  "lib/env": typeof lib_env;
  "lib/identity": typeof lib_identity;
  "lib/retention": typeof lib_retention;
  "lib/serverSecret": typeof lib_serverSecret;
  library: typeof library;
  "model/assignmentShapes": typeof model_assignmentShapes;
  "model/assignments": typeof model_assignments;
  "model/enrollment": typeof model_enrollment;
  "model/fluency": typeof model_fluency;
  "model/legacyImport": typeof model_legacyImport;
  "model/orientation": typeof model_orientation;
  "model/readerCopy": typeof model_readerCopy;
  "model/recording": typeof model_recording;
  "model/research": typeof model_research;
  "model/runShapes": typeof model_runShapes;
  "model/runStore": typeof model_runStore;
  "model/runs": typeof model_runs;
  "model/submission": typeof model_submission;
  "model/validators": typeof model_validators;
  "model/voiceFollow": typeof model_voiceFollow;
  "model/withdrawal": typeof model_withdrawal;
  "model/worksheets": typeof model_worksheets;
  "orientation/awrf": typeof orientation_awrf;
  "orientation/interactions": typeof orientation_interactions;
  "orientation/parentChoice": typeof orientation_parentChoice;
  "orientation/phases": typeof orientation_phases;
  "orientation/runs": typeof orientation_runs;
  "orientation/sessions": typeof orientation_sessions;
  "orientation/state": typeof orientation_state;
  "orientation/worker": typeof orientation_worker;
  rateLimits: typeof rateLimits;
  readerCopy: typeof readerCopy;
  research: typeof research;
  stats: typeof stats;
  voiceFollow: typeof voiceFollow;
  worksheets: typeof worksheets;
}> = anyApi as any;

/**
 * A utility for referencing Convex functions in your app's public API.
 *
 * Usage:
 * ```js
 * const myFunctionReference = api.myModule.myFunction;
 * ```
 */
export const api: FilterApi<
  typeof fullApi,
  FunctionReference<any, "public">
> = anyApi as any;

/**
 * A utility for referencing Convex functions in your app's internal API.
 *
 * Usage:
 * ```js
 * const myFunctionReference = internal.myModule.myFunction;
 * ```
 */
export const internal: FilterApi<
  typeof fullApi,
  FunctionReference<any, "internal">
> = anyApi as any;

export const components = componentsGeneric() as unknown as {};
